import { Kicker, MaskedLine, Reveal } from "@/components/Motion";
import ServiceCard from "@/components/ServiceCard";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <div data-testid="services-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <Kicker>Services — 13 categories</Kicker>
          <h1 className="mt-4 font-display font-bold tracking-tight text-slate-900">
            <MaskedLine delay={0.1} className="text-4xl sm:text-5xl">
              What NUC Service
            </MaskedLine>
            <MaskedLine delay={0.22} className="text-4xl text-blue-900 sm:text-5xl">
              can do for you
            </MaskedLine>
          </h1>
          <Reveal delay={0.35} className="mt-6 max-w-2xl">
            <p className="text-base leading-relaxed text-slate-700">
              Every service lists its eligibility, required documents and fee upfront. Open a
              service to see details, then book in under two minutes.
            </p>
          </Reveal>
        </div>
      </header>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.05}>
              <ServiceCard service={s} />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
